






































import { MobileBookingDTO } from '@accounting/interfaces/fallback-mobile-app-payment';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-payment-result-booking-card',
  components: {},
})
export default class PaymentResultBookingCard extends Vue {
  @Prop({ type: Object }) readonly bookingEvent: MobileBookingDTO;

  get statusVariant() {
    const status = this.bookingEvent.status;
    switch (status) {
      case 'draft':
        return 'secondary';
      case 'requested':
        return 'warning';
      case 'confirmed':
        return 'primary';
      case 'cancelled':
        return 'danger';
      case 'refused':
        return 'danger';
      default:
        return 'primary';
    }
  }

  get statusTranslation() {
    const status = this.bookingEvent.status;
    switch (status) {
      case 'draft':
        return this.$t('global.status.draft');
      case 'requested':
        return this.$t('global.status.requested');
      case 'confirmed':
        return this.$t('global.status.confirmed');
      case 'cancelled':
        return this.$t('global.status.cancelled');
      case 'refused':
        return this.$t('global.status.refused');
      default:
        return this.$t('global.status.draft');
    }
  }
}
